var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSectors = function SvgSectors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 4 18 h 5 V 5 H 4 v 13 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 10 18 h 5 v -6 h -5 v 6 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 16 18 h 5 v-6 h-5 v 6 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 10 5 v 6 h 11 V 5 H 10 z"
  })));
};
export { SvgSectors as ReactComponent };